import { memo } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { QuestionsFromAudienceStaticContent } from '@core-api/presentation/types/response';
import {
  usePresentationContext,
  usePresentationSlideContext,
} from '../../legacy-context/presentationContext';
import { TitleSection } from '../../shared/components/title-section/TitleSection';
import { NonInteractiveVisualizationWrapper } from '../../shared/components/NonInteractiveVisualizationWrapper';
import type { ModeT } from '../../types';
import { Display } from './components/Display';
import { Public } from './components/Public';
import { Screenshot } from './components/Screenshot';

const Renderer = memo(({ mode }: { mode: ModeT }) => {
  if (mode === 'public') return <Public />;
  if (mode === 'screenshot') return <Screenshot />;
  return <Display />;
});

export function QfaPresentation() {
  const { useConfig, InteractiveCanvasComponents } = usePresentationContext();

  const slide = usePresentationSlideContext();
  const staticContent =
    slide.staticContent as QuestionsFromAudienceStaticContent;
  const { mode } = useConfig();

  const ConditionalWrapper =
    InteractiveCanvasComponents?.CanvasVisualizationArea
      ? InteractiveCanvasComponents?.CanvasVisualizationArea
      : NonInteractiveVisualizationWrapper;

  return (
    <Box width="100%" height="100%" display="flex">
      <TitleSection
        title={slide.title}
        styledTitle={staticContent.styledTitle as Record<string, unknown>}
        description={staticContent.additionalDetails}
        label={staticContent.label}
        fontSizeOffset={staticContent.textSizeOffset}
        mb="space4"
        showTextSizeDropdown={true}
      />
      <ConditionalWrapper
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
        flex="1 1 auto"
      >
        <Renderer mode={mode} />
      </ConditionalWrapper>
    </Box>
  );
}
